import qs from "qs";
import moment_ from 'moment';
const moment = moment_;

/**
 * @author kai8wz
 * @date 2018-12
 * @licensor Robert Bosch GmbH, 2018
 * @version 1.0.0
 *
 * @jsdoc request
 * @name api.requests:GetOrdersRequest
 * @description
 * Order header request holding API query parameters.
 * See https://sourcecode.socialcoding.bosch.com/projects/CIBDX/repos/rb.core.order-api/browse/rbcore-order-api.yml.
 */
export class GetOrdersRequest {
  pageSize: number | null = null;
  offset: number | null = null;
  startDate: Date | null = null;
  endDate: Date | null = null;
  orderNo: string | null = null;
  invoiceNo: string | null = null;
  productId: string | null = null;
  purchaseOrderNo: string | null = null;
  orderReason: string | null = null;
  rejectionReason: string | null = null;
  orderStatus1: string | null = null;
  orderStatus2: string | null = null;
  orderStatus3: string | null = null;
  orderStatus4: string | null = null;
  orderStatus5: string | null = null;
  orderStatus6: string | null = null;
  orderStatus7: string | null = null;
  orderStatus8: string | null = null;
  process: string | null = null;
  brand: string | null = null;
  reason: string | null = null;
  sortBy: string | null = null;

  /**
   * @jsdoc method
   * @name constructor
   * @methodOf api.requests:GetOrdersRequest
   * @description description
   * Sets request query default parameters.
   */
  constructor(startDate?, endDate?, numberOfRecords?, sortBy?) {
    const offSet = new Date().getTimezoneOffset()*60000;
    this.startDate = startDate ? new Date(new Date(startDate).getTime() + offSet) : null;
    this.endDate = endDate ? new Date(new Date(endDate).getTime() + offSet) : null;
    this.pageSize = numberOfRecords;
    this.sortBy = sortBy;
  }


  /**
   * @jsdoc method
   * @name setQueryParam
   * @methodOf api.requests:GetOrdersRequest
   * @description description
   * Sets request query parameter. Allows only parameters that are class atributes
   */
  setQueryParam(name, value) {
    if (this.hasOwnProperty(name)) {
      this[name] = value === '' ? null : value;
    }
  }

  resetUniqueParams() {
    this.orderNo = null;
    this.invoiceNo = null;
    this.productId = null;
    this.purchaseOrderNo = null;
  }

  /**
   * @jsdoc method
   * @name toQueryString
   * @methodOf api.requests:GetOrdersRequest
   * @description description
   * Builds query string from class atributes.
   * Uses qs for query string and moment.js for date formatting according to interface requirements
   */
  toQueryString() {
    return qs.stringify(this, {
      addQueryPrefix: true,
      skipNulls: true,
      sort: null,
      serializeDate: (d) => { return moment(d).format('YYYY-MM-DD'); }
    });
  }
}
